const getToken = () => {
  const usuario = JSON.parse(localStorage.getItem("user"));
  if (usuario && usuario.token) {
    return usuario.token;
  } else {
    return false;
  }
}
export default getToken;